// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Zet","top":"styles_top__296oY"};